import { useProjectDataPanel } from '@trimble/project-data-panel-ui';
import { JSX } from 'solid-js';
import { WorkspacesSelectionTreeContainer } from '../WorkspacesSelectionTreeContainer';
import { WorkspaceTreeItem } from '../workspace-tree-nodes';
import { ProjectDataTreeContainerProps } from './shared-panel.types';

export type SharedWorkspacesTreeContainerProps =
  ProjectDataTreeContainerProps<WorkspaceTreeItem>;

export const SharedWorkspacesTreeContainer = (
  props: SharedWorkspacesTreeContainerProps
): JSX.Element => {
  const { filterText, sortBy, sortDirection, filterMode } =
    useProjectDataPanel();

  return (
    <WorkspacesSelectionTreeContainer
      nodes={props.nodes ?? []}
      childrenLoadStatus={props.childrenLoadStatus}
      filterText={props.nodes === undefined ? filterText() : undefined}
      sortBy={sortBy()}
      sortDirection={sortDirection()}
      filterMode={filterMode()}
    />
  );
};
